var map = {
	"./banner1.jpeg": 745,
	"./banner10.jpeg": 487,
	"./banner2.jpeg": 8,
	"./banner3.jpeg": 599,
	"./banner4.jpeg": 6,
	"./banner5.jpeg": 621,
	"./banner6.jpeg": 748,
	"./banner7.jpeg": 483,
	"./banner8.jpeg": 10,
	"./banner9.jpeg": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 519;